import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const paymentTerms: ComponentTemplate = {
  id: "payment-terms-template",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Payment Terms",
  leftBarCategory: { main: "product", subCategory: "productData" },
  preview: "product/payment-terms.svg",
  tags: ["product", "payment terms", "installments"],
  transforms: [],
  template: {
    id: "$uid",
    type: "paymentTerms",
    props: {},
  },
};
